import { Reading } from 'portal/components/Utilities/Readings/Interface'

export const READINGS_LOAD = 'READINGS_LOAD'
export const readingsLoad = (
  accountId: string,
  projectId: string
): ReadingsLoadAction => ({
  type: READINGS_LOAD,
  accountId,
  projectId
})

export const READINGS_LOAD_SUCCESS = 'READINGS_LOAD_SUCCESS'
export const readingsLoadSuccess = (
  accountId: string,
  projectId: string,
  readings: Reading[]
): ReadingsLoadSuccessAction => ({
  type: READINGS_LOAD_SUCCESS,
  accountId,
  projectId,
  readings
})

export const READINGS_LOAD_FAIL = 'READINGS_LOAD_FAIL'
export const readingsLoadFailure = (
  accountId: string,
  projectId: string,
  error
): ReadingsLoadFailAction => ({
  type: READINGS_LOAD_FAIL,
  accountId,
  projectId,
  error
})

export const ADD_READING = 'ADD_READING'
export const addReading = (
  accountId: string,
  projectId: string,
  meterId: string,
  readingDateTime: string,
  actualValue: number,
  notes: string,
  isEstimated: boolean,
  hasRolledOver: boolean,
  reload: () => void,
  showSuccessNotification: () => void,
  showFailureNotification: () => void
): AddReadingAction => ({
  type: ADD_READING,
  accountId,
  projectId,
  meterId,
  readingDateTime,
  actualValue,
  notes,
  isEstimated,
  hasRolledOver,
  reload,
  showSuccessNotification,
  showFailureNotification
})

export const ADD_READING_SUCCESS = 'ADD_READING_SUCCESS'
export const addReadingSuccess = (
  accountId: string,
  projectId: string,
  reading: Reading
): AddReadingSuccessAction => ({
  type: ADD_READING_SUCCESS,
  accountId,
  projectId,
  reading
})

export const ADD_READING_FAIL = 'ADD_READING_FAIL'
export const addReadingFailure = (
  accountId: string,
  projectId: string,
  error: any
): AddReadingFailAction => ({
  type: ADD_READING_FAIL,
  accountId,
  projectId,
  error
})

export const EDIT_READING = 'EDIT_READING'
export const editReading = (
  accountId: string,
  projectId: string,
  readingId: string,
  eTag: string,
  meterId: string,
  readingDateTime: string,
  actualValue: number,
  notes: string,
  isEstimated: boolean,
  hasRolledOver: boolean,
  reload: () => void,
  showSuccessNotification: () => void,
  showFailureNotification: () => void
): EditReadingAction => ({
  type: EDIT_READING,
  accountId,
  projectId,
  readingId,
  eTag,
  meterId,
  readingDateTime,
  actualValue,
  notes,
  isEstimated,
  hasRolledOver,
  reload,
  showSuccessNotification,
  showFailureNotification
})

export const EDIT_READING_SUCCESS = 'EDIT_READING_SUCCESS'
export const editReadingSuccess = (
  accountId: string,
  projectId: string,
  reading: Reading
): EditReadingSuccessAction => ({
  type: EDIT_READING_SUCCESS,
  accountId,
  projectId,
  reading
})

export const EDIT_READING_FAIL = 'EDIT_READING_FAIL'
export const editReadingFailure = (
  accountId: string,
  projectId: string,
  error: any
): EditReadingFailAction => ({
  type: EDIT_READING_FAIL,
  accountId,
  projectId,
  error
})

export const DELETE_READING = 'DELETE_READING'
export const deleteReading = (
  accountId: string,
  projectId: string,
  meterId: string,
  readingId: string,
  eTag: string,
  reload: () => void
): DeleteReadingAction => ({
  type: DELETE_READING,
  accountId,
  projectId,
  meterId,
  readingId,
  eTag,
  reload
})

export const DELETE_READING_SUCCESS = 'DELETE_READING_SUCCESS'
export const deleteReadingSuccess = (
  accountId: string,
  projectId: string,
  reading: Reading
): DeleteReadingSuccessAction => ({
  type: DELETE_READING_SUCCESS,
  accountId,
  projectId,
  reading
})

export const DELETE_READING_FAIL = 'DELETE_READING_FAIL'
export const deleteReadingFailure = (
  accountId: string,
  projectId: string,
  readingId: string,
  error: any
): DeleteReadingFailAction => ({
  type: DELETE_READING_FAIL,
  accountId,
  projectId,
  readingId,
  error
})
// INTERFACEs
export interface ReadingsLoadAction {
  type: typeof READINGS_LOAD
  accountId: string
  projectId: string
}

interface ReadingsLoadSuccessAction {
  type: typeof READINGS_LOAD_SUCCESS
  accountId: string
  projectId: string
  readings: Reading[]
}

interface ReadingsLoadFailAction {
  type: typeof READINGS_LOAD_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface AddReadingAction {
  type: typeof ADD_READING
  accountId: string
  projectId: string
  meterId: string
  readingDateTime: string
  actualValue: number
  notes: string
  isEstimated: boolean
  hasRolledOver: boolean
  reload: () => void
  showSuccessNotification: () => void
  showFailureNotification: () => void
}

interface AddReadingSuccessAction {
  type: typeof ADD_READING_SUCCESS
  accountId: string
  projectId: string
  reading: Reading
}

interface AddReadingFailAction {
  type: typeof ADD_READING_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface EditReadingAction {
  type: typeof EDIT_READING
  accountId: string
  projectId: string
  readingId: string
  eTag: string
  meterId: string
  readingDateTime: string
  actualValue: number
  notes: string
  isEstimated: boolean
  hasRolledOver: boolean
  reload: () => void
  showSuccessNotification: () => void
  showFailureNotification: () => void
}
interface EditReadingSuccessAction {
  type: typeof EDIT_READING_SUCCESS
  accountId: string
  projectId: string
  reading: Reading
}
interface EditReadingFailAction {
  type: typeof EDIT_READING_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface DeleteReadingAction {
  type: typeof DELETE_READING
  accountId: string
  projectId: string
  meterId: string
  readingId: string
  eTag: string
  reload: () => void
}
interface DeleteReadingSuccessAction {
  type: typeof DELETE_READING_SUCCESS
  accountId: string
  projectId: string
  reading: Reading
}
interface DeleteReadingFailAction {
  type: typeof DELETE_READING_FAIL
  accountId: string
  projectId: string
  readingId: string
  error: any
}
